import { graphql } from "~/gql";

export const LIBRARY_TECHNOLOGIES_QUERY = graphql(/* GraphQL */ `
  query FindLibraryTechnologies {
    libraryTechnologies {
      ...LibraryTechnologyParts
    }
  }
`);
